<template>
  <div>
    <h6>Action taking user tags :</h6>
    <span>
      <Chip class="p-mr-1 p-mb-1 custom-multi-chip-vidhan sidepadding">[#clientloginurl#]</Chip>
      <Chip class="p-mr-1 p-mb-1 custom-multi-chip-vidhan sidepadding">[#mobileapplink#]</Chip>
      <Chip class="p-mr-1 p-mb-1 custom-multi-chip-vidhan sidepadding">[#actiontakinguserfirstname#]</Chip>
      <Chip class="p-mr-1 p-mb-1 custom-multi-chip-vidhan sidepadding">[#actiontakingusershortname#]</Chip>
      <Chip class="p-mr-1 p-mb-1 custom-multi-chip-vidhan sidepadding">[#actiontakinguserfullname#]</Chip>
      <Chip class="p-mr-1 p-mb-1 custom-multi-chip-vidhan sidepadding">[#actiontakinguseremailid#]</Chip>
      <Chip class="p-mr-1 p-mb-1 custom-multi-chip-vidhan sidepadding">[#actiontakinguserprimarymobilenumber#]</Chip>
      <Chip class="p-mr-1 p-mb-1 custom-multi-chip-vidhan sidepadding">[#actiontakinguserpassword#]</Chip>
      <Chip class="p-mr-1 p-mb-1 custom-multi-chip-vidhan sidepadding">[#actiontakingusercurrentaddress#]</Chip>
      <Chip class="p-mr-1 p-mb-1 custom-multi-chip-vidhan sidepadding">[#actiontakinguserphotofilename#]</Chip>
      <Chip class="p-mr-1 p-mb-1 custom-multi-chip-vidhan sidepadding">[#clientname#]</Chip>
      <Chip class="p-mr-1 p-mb-1 custom-multi-chip-vidhan sidepadding">[#personalmessage#]</Chip>
      <Chip class="p-mr-1 p-mb-1 custom-multi-chip-vidhan sidepadding">[#otp#]</Chip>
      <Chip class="p-mr-1 p-mb-1 custom-multi-chip-vidhan sidepadding">[#emailverificationlink#]</Chip>
      <Chip class="p-mr-1 p-mb-1 custom-multi-chip-vidhan sidepadding">[#code#]</Chip>
      <Chip class="p-mr-1 p-mb-1 custom-multi-chip-vidhan sidepadding">[#actiontakinguserfirstnamewithspace#]</Chip>
    </span>
    <Divider />
    <h6>Admin employee tags :</h6>
    <span>
      <Chip class="p-mr-1 p-mb-1 custom-multi-chip-vidhan sidepadding">[#clientloginurl#]</Chip>
      <Chip class="p-mr-1 p-mb-1 custom-multi-chip-vidhan sidepadding">[#mobileapplink#]</Chip>
      <Chip class="p-mr-1 p-mb-1 custom-multi-chip-vidhan sidepadding">[#adminusershortname#]</Chip>
      <Chip class="p-mr-1 p-mb-1 custom-multi-chip-vidhan sidepadding">[#adminuserfullname#]</Chip>
      <Chip class="p-mr-1 p-mb-1 custom-multi-chip-vidhan sidepadding">[#adminuseremailid#]</Chip>
      <Chip class="p-mr-1 p-mb-1 custom-multi-chip-vidhan sidepadding">[#adminuserprimarymobilenumber#]</Chip>
      <Chip class="p-mr-1 p-mb-1 custom-multi-chip-vidhan sidepadding">[#adminuserpassword#]</Chip>
      <Chip class="p-mr-1 p-mb-1 custom-multi-chip-vidhan sidepadding">[#adminusercurrentaddress#]</Chip>
      <Chip class="p-mr-1 p-mb-1 custom-multi-chip-vidhan sidepadding">[#adminuserphotofilename#]</Chip>
      <Chip class="p-mr-1 p-mb-1 custom-multi-chip-vidhan sidepadding">[#clientname#]</Chip>
      <Chip class="p-mr-1 p-mb-1 custom-multi-chip-vidhan sidepadding">[#loginusername#]</Chip>
      <Chip class="p-mr-1 p-mb-1 custom-multi-chip-vidhan sidepadding">[#adminuserfirstname#]</Chip>
      <Chip class="p-mr-1 p-mb-1 custom-multi-chip-vidhan sidepadding">[#adminuserfirstnamewithspace#]</Chip>
    </span>
    <Divider />
    <h6>Citizen tags :</h6>
    <span>
      <Chip class="p-mr-1 p-mb-1 custom-multi-chip-vidhan sidepadding">[#clientloginurl#]</Chip>
      <Chip class="p-mr-1 p-mb-1 custom-multi-chip-vidhan sidepadding">[#mobileapplink#]</Chip>
      <Chip class="p-mr-1 p-mb-1 custom-multi-chip-vidhan sidepadding">[#citizenshortname#]</Chip>
      <Chip class="p-mr-1 p-mb-1 custom-multi-chip-vidhan sidepadding">[#citizenfullname#]</Chip>
      <Chip class="p-mr-1 p-mb-1 custom-multi-chip-vidhan sidepadding">[#citizenemailid#]</Chip>
      <Chip class="p-mr-1 p-mb-1 custom-multi-chip-vidhan sidepadding">[#citizenprimarymobilenumber#]</Chip>
      <Chip class="p-mr-1 p-mb-1 custom-multi-chip-vidhan sidepadding">[#citizencurrentaddress#]</Chip>
      <Chip class="p-mr-1 p-mb-1 custom-multi-chip-vidhan sidepadding">[#citizenphotofilename#]</Chip>
      <Chip class="p-mr-1 p-mb-1 custom-multi-chip-vidhan sidepadding">[#clientname#]</Chip>
      <Chip class="p-mr-1 p-mb-1 custom-multi-chip-vidhan sidepadding">[#registrationurl#]</Chip>
      <Chip class="p-mr-1 p-mb-1 custom-multi-chip-vidhan sidepadding">[#datetime#]</Chip>
      <Chip class="p-mr-1 p-mb-1 custom-multi-chip-vidhan sidepadding">[#hour#]</Chip>
      <Chip class="p-mr-1 p-mb-1 custom-multi-chip-vidhan sidepadding">[#area#]</Chip>
      <Chip class="p-mr-1 p-mb-1 custom-multi-chip-vidhan sidepadding">[#url#]</Chip>
      <Chip class="p-mr-1 p-mb-1 custom-multi-chip-vidhan sidepadding">[#otp#]</Chip>
      <Chip class="p-mr-1 p-mb-1 custom-multi-chip-vidhan sidepadding">[#companyname#]</Chip>
      <Chip class="p-mr-1 p-mb-1 custom-multi-chip-vidhan sidepadding">[#pass#]</Chip>
      <Chip class="p-mr-1 p-mb-1 custom-multi-chip-vidhan sidepadding">[#app#]</Chip>
      <Chip class="p-mr-1 p-mb-1 custom-multi-chip-vidhan sidepadding">[#service#]</Chip>
      <Chip class="p-mr-1 p-mb-1 custom-multi-chip-vidhan sidepadding">[#certificateurl#]</Chip>
      <Chip class="p-mr-1 p-mb-1 custom-multi-chip-vidhan sidepadding">[#citizenfirstnamewithspace#]</Chip>
      <Chip class="p-mr-1 p-mb-1 custom-multi-chip-vidhan sidepadding">[#citizenfirstname#]</Chip>
      <Chip class="p-mr-1 p-mb-1 custom-multi-chip-vidhan sidepadding">[#premisesname#]</Chip>
      <Chip class="p-mr-1 p-mb-1 custom-multi-chip-vidhan sidepadding">[#certificatetype#]</Chip>
    </span>
    <Divider />
    <h6>Support user tags :</h6>
    <span>
      <Chip class="p-mr-1 p-mb-1 custom-multi-chip-vidhan sidepadding">[#clientloginurl#]</Chip>
      <Chip class="p-mr-1 p-mb-1 custom-multi-chip-vidhan sidepadding">[#accesscode#]</Chip>
      <Chip class="p-mr-1 p-mb-1 custom-multi-chip-vidhan sidepadding">[#mobileapplink#]</Chip>
      <Chip class="p-mr-1 p-mb-1 custom-multi-chip-vidhan sidepadding">[#supportusershortname#]</Chip>
      <Chip class="p-mr-1 p-mb-1 custom-multi-chip-vidhan sidepadding">[#supportuserfullname#]</Chip>
      <Chip class="p-mr-1 p-mb-1 custom-multi-chip-vidhan sidepadding">[#supportuseremailid#]</Chip>
      <Chip class="p-mr-1 p-mb-1 custom-multi-chip-vidhan sidepadding">[#supportuserprimarymobilenumber#]</Chip>
      <Chip class="p-mr-1 p-mb-1 custom-multi-chip-vidhan sidepadding">[#supportuserpassword#]</Chip>
      <Chip class="p-mr-1 p-mb-1 custom-multi-chip-vidhan sidepadding">[#supportuseraadharnumber#]</Chip>
      <Chip class="p-mr-1 p-mb-1 custom-multi-chip-vidhan sidepadding">[#supportusercurrentaddress#]</Chip>
      <Chip class="p-mr-1 p-mb-1 custom-multi-chip-vidhan sidepadding">[#supportuserphotofilename#]</Chip>
      <Chip class="p-mr-1 p-mb-1 custom-multi-chip-vidhan sidepadding">[#clientname#]</Chip>

    </span>
    <Divider />
    <h6>Current user tags :</h6>
    <span>
      <Chip class="p-mr-1 p-mb-1 custom-multi-chip-vidhan sidepadding">[#clientloginurl#]</Chip>
      <Chip class="p-mr-1 p-mb-1 custom-multi-chip-vidhan sidepadding">[#mobileapplink#]</Chip>
      <Chip class="p-mr-1 p-mb-1 custom-multi-chip-vidhan sidepadding">[#currentusershortname#]</Chip>
      <Chip class="p-mr-1 p-mb-1 custom-multi-chip-vidhan sidepadding">[#currentuserfullname#]</Chip>
      <Chip class="p-mr-1 p-mb-1 custom-multi-chip-vidhan sidepadding">[#currentuseremailid#]</Chip>
      <Chip class="p-mr-1 p-mb-1 custom-multi-chip-vidhan sidepadding">[#currentuserprimarymobilenumber#]</Chip>
      <Chip class="p-mr-1 p-mb-1 custom-multi-chip-vidhan sidepadding">[#currentuserpassword#]</Chip>
      <Chip class="p-mr-1 p-mb-1 custom-multi-chip-vidhan sidepadding">[#currentusercurrentaddress#]</Chip>
      <Chip class="p-mr-1 p-mb-1 custom-multi-chip-vidhan sidepadding">[#currentuserphotofilename#]</Chip>
      <Chip class="p-mr-1 p-mb-1 custom-multi-chip-vidhan sidepadding">[#clientname#]</Chip>
      <Chip class="p-mr-1 p-mb-1 custom-multi-chip-vidhan sidepadding">[#otp#]</Chip>
      <Chip class="p-mr-1 p-mb-1 custom-multi-chip-vidhan sidepadding">[#currentuserpersonalmessage#]</Chip>
      <Chip class="p-mr-1 p-mb-1 custom-multi-chip-vidhan sidepadding">[#app#]</Chip>
      <Chip class="p-mr-1 p-mb-1 custom-multi-chip-vidhan sidepadding">[#currentuserfirstname#]</Chip>
      <Chip class="p-mr-1 p-mb-1 custom-multi-chip-vidhan sidepadding">[#code#]</Chip>
      <Chip class="p-mr-1 p-mb-1 custom-multi-chip-vidhan sidepadding">[#currentuserfirstnamewithspace#]</Chip>
    </span>
  </div>
</template>

<script>
export default {
  data() {
    return {
    };
  },
};
</script>
<style>
.sidepadding {
  padding: 4px 10px;
}
</style>